import React, { Component, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import logo from "../../assets/images/logo-default.svg";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";
import vector1 from "../../assets/images/icon_login/vector1.svg";
import banner from "../../assets/images/icon_stock/banner.svg";
import Company from "../../core/models/company";
import { Link, useNavigate } from "react-router-dom";
import User from "../../core/models/user.js";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import fingerPrint from "@fingerprintjs/fingerprintjs";
import Token from "../../core/models/token.js";
import { findIndex } from "lodash";
import { setToken } from "../../core/feature/token/tokenSlice";
import * as api_balance from "../../core/service/api_balance";
import { toast } from "react-toastify";
import { setLoading } from "../../core/feature/config/configSlice";
import { Transition } from "@headlessui/react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getBroadcastData } from "../../core/service/api_notification.js";
import Config from "../../config/Config";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { setLastService } from "../../core/feature/lastService/lastServiceSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/balance/balanceSlice";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css/autoplay";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker.jsx";
import eventTrackerAnalytics from "../../core/service/eventTrackerAnalytics.jsx";

const LoginWeb = () => {
  const gaEventTracker = useAnalyticsEventTracker("External Link");

  const user: User = useAppSelector((state) => state.user.user);
  const { t } = useTranslation();
  const [dataBroadcast, setDataBroadcast] = useState<any>([]);

  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [typePassword, setTypePassword] = useState("password");

  const [otherOpened, setOtherOpened] = useState(false);
  const [supportOpened, setSupportOpened] = useState(false);
  const [broadcastOpened, setBroadcastOpened] = useState(false);

  const [supportMessage, setSupportMessage] = useState("");
  const [supportUsername, setSupportUsername] = useState("");
  const [supportInstitute, setSupportInstitute] = useState("");
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [showCS, setShowCS] = useState(false);
  const navigate = useNavigate();
  const dispact = useAppDispatch();
  const env = Config.BaseUrlDev;
  var name = `${t("CUSTOMER.name")}`;
  var institution = `${t("CUSTOMER.institution")}`;
  var message = `${t("CUSTOMER.message")}`;

  const login = async () => {
    var CryptoJS = require("crypto-js");
    var username = usernameRef.current?.value;
    var password = passwordRef.current?.value;
    var data = {
      username: username,
      password: password,
    };

    dispact(setLoading(true));
    API.login(data)
      .then((res) => {
        dispact(setLoading(false));

        dispact(setLastService(res.data.user.lastService));
        dispact(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck().then((resCredential) => {
          console.log("cradential", "sdjf");
          if (resCredential.data.user.accounts[0].roles.includes("ROLE_USER")) {
            if (res.data.firstLogin) {
              var ciphertext = CryptoJS.AES.encrypt(
                JSON.stringify(data),
                "credential"
              ).toString();
              localStorage.setItem("credential", ciphertext);
              navigate("/confirmation-data", {
                replace: true,
                state: {
                  credential: data,
                  email: resCredential.data.user.email,
                  phone: resCredential.data.user.phone,
                },
              });
            } else {
              var auto = "1";
              var ciphertext = CryptoJS.AES.encrypt(
                JSON.stringify(data),
                "credential"
              ).toString();
              localStorage.setItem("credential", ciphertext);
              localStorage.setItem("auto_login", auto);
              dispact(setUser(resCredential.data.user));
              api_balance.getBalance().then((balance) => {
                dispact(setBalance(balance.data.balance));

                if (res.data.user.lastService == "KATALIS") {
                  API.getCustomApps(
                    resCredential.data.activeCompany.id,
                    "ID"
                  ).then((resCustom: any) => {
                    console.log(resCustom.data);
                    dispact(setCustomApp(resCustom.data));
                    navigate("/home", { replace: true });
                  });
                } else {
                  dispact(removeUser());
                  dispact(removeBalance());
                  dispact(removeCompany());
                  toast.error(t("LOGIN.accessInvalid"));
                  navigate("/login", { replace: true });
                }
              });
            }
          } else {
            return toast.error(t("LOGIN.accessInvalid"));
          }
        });
      })
      .catch((err) => {
        dispact(setLoading(false));
        // toast.error(t("LOGIN.wrongLogin"));
      });
  };
  const funTypePassword = async () => {
    if (typePassword == "text") {
      setTypePassword("password");
    } else {
      setTypePassword("text");
    }
  };

  function openSupport() {
    setSupportOpened(true);
    setOpenDetailHistory(false);
  }

  function closeSupport() {
    setSupportOpened(false);
  }

  function openBroadcast() {
    setBroadcastOpened(true);
  }

  function closeBroadcast() {
    setBroadcastOpened(false);
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function sendMessage() {
    console.log(supportMessage);
    let url = "";
    let phone = "6281326269992";
    url =
      "https://wa.me/" +
      phone +
      "?text=Halo,%20saya%20" +
      supportUsername +
      "%20dari%20" +
      supportInstitute +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A" +
      supportMessage;
    gaEventTracker("Customer Service Visit", url);
    setSupportOpened(false);
    window.open(url, "_blank");
  }

  function funBcData() {
    getBroadcastData("ACTIVE", "MOBILE")
      .then((res) => {
        if (res.data.content.length > 0) {
          setDataBroadcast(res.data.content);
          console.log(res.data.content, "Broadcast");
          if (JSON.parse(String(localStorage.getItem("broadcast"))) == "0") {
            openBroadcast();
          }
        } else {
          console.log(res, "kosong");
        }
      })
      .catch((err: any) => {
        console.log(err, "kosong");
      });
  }
  const getCredential = () => {
    let cred = window.localStorage.getItem("credential")
    if (cred){
      var CryptoJS = require("crypto-js");
      var getCredential = localStorage.getItem("credential");

      var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      var data = decryptedData;
      if(usernameRef.current && passwordRef.current){
        usernameRef.current.value = data.username;
        passwordRef.current.value = data.password;
      }
    }
  }
  useEffect(() => {
    localStorage.setItem("broadcast", "0");
    funBcData();
    var CryptoJS = require("crypto-js");
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify("Teserrr"),
      "password"
    ).toString();

    var bytes = CryptoJS.AES.decrypt(ciphertext, "password");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    if (user?.name) {
      navigate("/home", { replace: true });
    }
    getCredential()
  }, []);

  return (
    <>
      <div className="relative font-poppins p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          {/* <div>
            <img src={vector1} className="top-0 left-0 absolute z-10" />
          </div> */}
          <div className="relative overflow-visible w-3/12 sm:w-1/2 md:w-3/12 flex-0 bg-psp-login ">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="flex flex-col gap-10 w-full">
              <div className="flex flex-col z-10 gap-8 items-start">
                <img src={vector1} className="ml-32 sm:ml-12 md:ml-32" />
                <div className="px-10 mt-36 sm:px-10  md:px-10 md:mt-20 sm:mt-0">
                  <img src={logoWhite} className="z-10 h-14 select-none" />
                  <p className="text-white z-10 mt-6 text-xs font-light">
                    {t("LOGIN.description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grow p-12 bg-psp-primary relative">
            <img src={ellipse3} className="absolute top-0 -left-72 z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 z-0" />
            <div className="w-1/2 md:w-2/3 sm:w-full m-auto">
              <div className="pt-40">
                <h1 className="text-gray-400 text-2xl font-medium select-none">
                  Welcome To
                </h1>
                <p className="text-black font-semibold text-4xl select-none">
                  PSP Web Desktop
                </p>
              </div>
              <div className="my-2">
                <h4 className="text-left text-lg font-semibold text-psp-primary select-none">
                  Login
                </h4>
              </div>
              <div className="relative">
                <div className="flex flex-col gap-2 mb-4">
                  <h1 className="text-sm text-gray-400 font-medium pl-1 mb-0 select-none">
                    Username
                  </h1>
                  <input
                    ref={usernameRef}
                    type="text"
                    className="grow py-2 px-3 focus:border-gray-300 active:border-gray-200 rounded-sm h-12 border-1 border-solid border-gray-300 border-neutral- bg-white"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <h1 className="text-sm text-gray-400 font-medium pl-1 mb-0 select-none">
                    Password
                  </h1>
                  <input
                    type={typePassword}
                    ref={passwordRef}
                    className="grow py-2 px-3 focus:border-gray-300 active:border-gray-200 rounded-sm h-12 border-1 border-solid border-gray-300 border-neutral- bg-white"
                  />
                  <img
                    src={typePassword === "text" ? eye : eyeclose}
                    className="cursor-pointer w-8 absolute right-3 mt-9"
                    onClick={() => funTypePassword()}
                  />
                </div>
                <div className="w-full">
                  <p
                    onClick={() => {
                      navigate("/forgot-password");
                    }}
                    className="px-3 hover:text-slate-500 m-0 py-2 text-end font-medium text-psp-gray text-xs cursor-pointer"
                  >
                    {t("LOGIN.forgotPassword")}
                  </p>
                </div>
                <div className="flex flex-col gap-3 ">
                  <button
                    onClick={() => {
                      eventTrackerAnalytics.bind(
                        this,
                        "Log In Screen",
                        "Log In Button",
                        "Button"
                      );
                      login();
                    }}
                    className="w-full shadow-xl mt-8 h-12 rounded-sm text-white font-semibold text-base bg-psp-btn-primary hover:ring-2 hover:ring-blue-300 active:bg-psp-active"
                  >
                    Login
                  </button>
                </div>
                <div className="w-1/2 m-auto mt-4">
                  <p className="px-3 m-0 py-2 whitespace-pre-line text-center font-medium text-psp-gray text-xs select-none">
                    {t("LOGIN.help")}
                    <br />
                    <button
                      onClick={() => setShowCS(true)}
                      className="underline text-psp-primary cursor-pointer hover:text-blue-800"
                    >
                      {t("CUSTOMER.title")}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Transition
        show={broadcastOpened}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
            <div className="relative w-full min-w-[400px] h-auto my-6 mx-auto max-w-3xl max-h-[790px] bg-white rounded-xl ">
              <div className="w-full p-3 text-xl shadow-md">
                {dataBroadcast.map((item: any, i: any) => {
                  if (i === 0) return <span>{item.title}</span>;
                })}
              </div>
              <div className="p-4 pb-5 bg-psp-primary shadow-md">
                <div className="bg-white rounded-xl shadow">
                  {dataBroadcast.map((item: any, index: any) => {
                    if (index === 0) {
                      if (item.broadcastType === "IMAGE")
                        return (
                          <div className="w-auto h-auto pb-2">
                            <Swiper
                              autoplay={true}
                              pagination={{ clickable: true, type: "fraction" }}
                              navigation
                              slidesPerView={1}
                              modules={[Pagination, Navigation, Autoplay]}
                            >
                              {item.imagesFirebase.map((a: any, i: any) => {
                                return (
                                  <SwiperSlide>
                                    <img
                                      key={i}
                                      src={a}
                                      alt=""
                                      className="max-h-[400px] rounded-xl flex mx-auto object-fill"
                                    ></img>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                            </div>
                          </div>
                        );
                      if (item.broadcastType === "TEXT")
                        return (
                          <div className="w-full h-auto py-1">
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <div className="mt-4">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.message,
                                  }}
                                ></span>
                              </div>
                            </div>
                          </div>
                        );
                    }
                  })}
                </div>
              </div>
              <div className="relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
                <div className="flex flex-row justify-center my-3">
                  <button
                    type="button"
                    className="w-40 h-10 rounded-xl text-white bg-psp-btn-red flex flex-row"
                    onClick={() => setBroadcastOpened(false)}
                  >
                    <span className="py-2.5 px-3">
                      <image>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.1971 6.79639L6.80273 10.1907"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.1979 10.1928L6.80078 6.79489"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.5702 1.94806H5.4297C3.28983 1.94806 1.94824 3.46318 1.94824 5.60731V11.393C1.94824 13.5371 3.28345 15.0522 5.4297 15.0522H11.5695C13.7165 15.0522 15.0524 13.5371 15.0524 11.393V5.60731C15.0524 3.46318 13.7165 1.94806 11.5702 1.94806Z"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </image>
                    </span>
                    <span className="font-bold mt-2 ml-3">
                      {t("LOGIN.close")}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>

      <Transition
        show={showCS}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
            <div className="relative w-auto h-auto my-6 mx-auto max-w-6xl">
              <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-psp-primary outline-none focus:outline-none py-4 px-4">
                <div className="text-xl font-semibold w-full h-auto text-center px-2 py-2 mb-3">
                  <span>{t("CUSTOMER.title")}</span>
                </div>
                <div>
                  <form>
                    <input
                      onChange={(e) => setSupportUsername(e.target.value)}
                      placeholder={name}
                      className="w-full py-2 px-3 border rounded-xl mb-2"
                    ></input>
                  </form>
                  <form>
                    <input
                      onChange={(e) => setSupportInstitute(e.target.value)}
                      placeholder={institution}
                      className="w-full py-2 px-3 border rounded-xl mb-2"
                    ></input>
                  </form>
                  <form>
                    <textarea
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder={message}
                      className="w-full py-2 px-3 border rounded-xl"
                    ></textarea>
                  </form>
                </div>
                <div className="mt-4 flex flex-row justify-center mb-1">
                  <button
                    type="button"
                    className="w-40 h-10 mr-3 rounded-md text-white bg-psp-btn-red"
                    onClick={() => setShowCS(false)}
                  >
                    {t("CUSTOMER.no")}
                  </button>
                  <button
                    type="button"
                    className="w-40 h-10 rounded-md text-white bg-psp-btn-primary"
                    onClick={() => sendMessage()}
                  >
                    {t("CUSTOMER.yes")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>
    </>
  );
};

export default LoginWeb;
